import React from 'react'
import { ResponsiveSVG } from 'ui/acro'
import { CommunityOther } from 'images/latest'

const CommunityOtherIcon = ({ color = 'black' }) => (
  <ResponsiveSVG
    width='47px'
    height='33px'
    className='unstyled'
    fill={color}
    SVG={CommunityOther}
  />
)

export default CommunityOtherIcon
